import { Logger, LoggerService } from "@Shared/logger";
import { NavigaLoaderOptions } from "./_models";
import { EngageService } from "./services";



export class EngageModuleClass {
    private Logger: Logger = LoggerService.createLogger("EngageModuleClass");


    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    public async init(options: NavigaLoaderOptions): Promise<void> {
        this.Logger.trace("setting up Engage Module...", options);
        try {
            
            await EngageService.Instance.init(options);
            
            return Promise.resolve();
        } catch (error) {
            throw error;
            
        }


    }

}


export const EngageModule = new EngageModuleClass();